import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import isPlainObject from 'lodash/isPlainObject.js';
import PendoButton from '../button/pendo-button.vue.js';
import PendoTooltip from '../../directives/tooltip/pendo-tooltip.js';

var script = {
  name: 'PendoIconButton',
  components: {
    PendoButton
  },
  directives: {
    PendoTooltip
  },
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      default: null
    },
    iconSize: {
      type: [String, Number],
      default: '16'
    },
    tooltip: {
      type: [String, Object],
      default: null
    }
  },
  computed: {
    tooltipConfig() {
      const defaults = {
        delay: {
          show: 300,
          hide: 0
        }
      };
      if (this.tooltip && isPlainObject(this.tooltip)) {
        return _objectSpread2(_objectSpread2({}, defaults), this.tooltip);
      }
      return _objectSpread2(_objectSpread2({}, defaults), {}, {
        content: this.tooltip
      });
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-icon-button.vue2.js.map
